import { LinkTo, StorefrontImage } from "../../../types";

import { Box } from "@vinomofo/components";
import { PrimaryBanner } from "./PrimaryBanner";
import { SecondaryBanner } from "./SecondaryBanner";

const textPositions = ["left", "right"] as const;
export type TextPosition = typeof textPositions[number];

export interface ThreeUpBannerProps {
  image: StorefrontImage;
  textPosition?: TextPosition;
  title?: string;
  subtitle?: string;
  titleColor?: string;
  subtitleColor?: string;
  primaryCta?: {
    buttonColour?: string;
    buttonBorderColor?: string;
    buttonTextColor?: string;
    buttonHoverBorderColor?: string;
    buttonHoverBackgroundColor?: string;
    buttonHoverTextColor?: string;
    label?: string;
    linkTo?: LinkTo;
  };
}

export interface ThreeUpBannerGroupProps {
  banners: Array<ThreeUpBannerProps>;
}

export const ThreeUpBannerGroup = ({
  banners,
}: ThreeUpBannerGroupProps): JSX.Element => {
  const [primaryBanner, ...secondaryBanners] = banners;

  return (
    <Box
      minHeight={["auto", "600px"]}
      display="grid"
      gridTemplateColumns={["1fr", "1fr 1fr", "2fr 1fr"]}
      gridTemplateRows={["2fr 1fr 1fr", "2fr 1fr", "1fr 1fr"]}
      gridTemplateAreas={[
        `"primary"
         "secondary-1"
         "secondary-2"
        `,
        `"primary primary"
         "secondary-1 secondary-2"
        `,
        `"primary secondary-1"
         "primary secondary-2"
        `,
      ]}
    >
      <PrimaryBanner gridArea="primary" {...primaryBanner} />
      {secondaryBanners.map((banner, i) => (
        <SecondaryBanner key={i} gridArea={`secondary-${i + 1}`} {...banner} />
      ))}
    </Box>
  );
};
